export interface SparklineProps {
  values: number[];
  color?: string;
  width?: number;
  height?: number;
}

export function SparklineCell({
  values,
  color = '#5C6AC4',
  width = 80,
  height = 24,
}: SparklineProps) {
  if (!values.length) {
    return (
      <div
        style={{
          width,
          height,
          background: 'var(--p-color-bg-surface-secondary)',
          borderRadius: 4,
        }}
      />
    );
  }

  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const step = width / Math.max(values.length - 1, 1);

  const points = values
    .map((v, i) => {
      const x = i * step;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  const lastX = (values.length - 1) * step;
  const lastY = height - ((values[values.length - 1] - min) / range) * (height - 4) - 2;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={lastX} cy={lastY} r="2.5" fill={color} />
    </svg>
  );
}
